import { MapPin } from "lucide-react";

export function mapsUrl(address) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

export function mapsRouteUrl(addresses) {
  const stops = (addresses || []).filter(Boolean);
  if (!stops.length) return null;
  // Omitting `origin` makes Google Maps start turn-by-turn from the user's
  // current location. Stops are visited in the order given (sorted by time).
  const destination = encodeURIComponent(stops[stops.length - 1]);
  let url = `https://www.google.com/maps/dir/?api=1&destination=${destination}&travelmode=driving`;
  const waypoints = stops.slice(0, -1).map((a) => encodeURIComponent(a)).join("|");
  if (waypoints) url += `&waypoints=${waypoints}`;
  return url;
}

export default function MapLink({ address, className = "", testid }) {
  if (!address) return null;
  return (
    <a
      href={mapsUrl(address)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      data-testid={testid}
      title="Open in Google Maps"
      className={`inline-flex items-center gap-1 text-primary hover:underline ${className}`}
    >
      <MapPin className="h-3.5 w-3.5 shrink-0" />
      <span className="truncate">{address}</span>
    </a>
  );
}
